import { StatusType, UrgencyType } from '@app/api-module/control-centre-api-client';
import { ModalityType } from '@app/shared/model/shared.model';
import { Interval } from 'luxon';

const WorklistFiltersActionsPrefix = '[Worklist Filters] ';

export class ApplyFilters {
    static readonly type = WorklistFiltersActionsPrefix + 'Apply Filters';
}

export class ClearFilters {
    static readonly type = WorklistFiltersActionsPrefix + 'Clear Filters';
}

export class ClearPendingFilters {
    static readonly type = WorklistFiltersActionsPrefix + 'Clear Pending Filters';
}

export class ResetPendingFilters {
    static readonly type = WorklistFiltersActionsPrefix + 'Reset Pending Filters';
}

export class AddModality {
    static readonly type = WorklistFiltersActionsPrefix + 'Add Modality';

    constructor(public filteredModality: ModalityType) {}
}

export class RemoveModality {
    static readonly type = WorklistFiltersActionsPrefix + 'Remove Modality';

    constructor(public filteredModality: ModalityType) {}
}

export class AddUrgency {
    static readonly type = WorklistFiltersActionsPrefix + 'Add Urgency';

    constructor(public filteredUrgency: UrgencyType) {}
}

export class RemoveUrgency {
    static readonly type = WorklistFiltersActionsPrefix + 'Remove Urgency';

    constructor(public filteredUrgency: UrgencyType) {}
}

export class AddStatus {
    static readonly type = WorklistFiltersActionsPrefix + 'Add Status';

    constructor(public filteredStatus: StatusType) {}
}

export class RemoveStatus {
    static readonly type = WorklistFiltersActionsPrefix + 'Remove Status';

    constructor(public filteredStatus: StatusType) {}
}

export class UpdateTimeRangeFilter {
    static readonly type = WorklistFiltersActionsPrefix + 'Update Filtered Time Range';

    constructor(public timeRangeFilter: Interval) {}
}
